var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoft365(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.375,
    height: 21,
    viewBox: "0 0 18.375 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ff5722;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.313)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.125,0,1.313,4.594V17.063L5.25,15.75V5.25l7.875-1.312v14.5L1.313,17.063,13.125,21l6.563-1.969V1.969Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoft365);
export default __webpack_public_path__ + "static/media/microsoft-365.9561ae1959bfbf49474b8bc9cd4ea370.svg";
export { ForwardRef as ReactComponent };